export default __webpack_public_path__ + "static/media/blackbird2.d891a649.jpg";